import { GasCalculationBase } from './base/gas-calculation-base';

export class GasCalculation extends GasCalculationBase { }